import React from 'react';
import { TableColumn } from '../../../types/search';
import PortalCellUrl from '../components/PortalCellUrl';
import PortalCellWasteType from '../components/PortalCellWasteType';
import PortalCellFrequency from '../components/PortalCellFrequency';
import PortalCellSite from '../components/PortalCellSite';
import PortalCellStatus from '../components/PortalCellStatus';
import PortalCellReferenceId from '../components/PortalCellReferenceId';
import PortalCellDateIssued from '../components/PortalCellDateIssued';
import PortalCellDateDue from '../components/PortalCellDateDue';
import PortalCellTotal from '../components/PortalCellTotal';
import PortalCellOutstandingBalance from '../components/PortalCellOutstandingBalance';
import PortalCellPay from '../components/PortalCellPay';
import PortalCellMobile from '../components/PortalCellMobile';
import PortalCellService from '../components/PortalCellService';
import PortalCellDate from '../components/PortalCellDate';
import PortalCellAttachments from '../components/PortalCellAttachments';

// Data defining columns for different portal listing types
// - 'key' should match facet key the column is sorted by
// - 'label' is a fallback, should come from the CMS
// - To add a checkbox column, add the following object as the
//   first item in the listing type array:
// {
//   key: 'checkbox',
//   label: '',
//   type: 'custom',
// },
export const columnData: Record<string, TableColumn[]> = {
  services: [
    {
      key: 'wasteType',
      label: 'Services',
      type: 'custom',
      customRender: (value: string, row: Record<string, unknown>, listingType: string) => (
        <PortalCellWasteType value={value} row={row} listingType={listingType} />
      ),
      skeletonCount: 2,
      width: '60%',
      skeletonWidths: ['100%', '80%'],
    },
    {
      key: 'frequency',
      label: 'Frequency',
      type: 'custom',
      customRender: (value: string, row: Record<string, unknown>, listingType: string) => (
        <PortalCellFrequency value={value} row={row} listingType={listingType} />
      ),
      skeletonCount: 2,
      width: '60%',
      skeletonWidths: ['100%', '50%'],
    },
    {
      key: 'site',
      label: 'Location',
      type: 'custom',
      customRender: (value: string, row: Record<string, unknown>, listingType: string) => (
        <PortalCellSite value={value} row={row} listingType={listingType} />
      ),
      skeletonCount: 1,
      width: '80%',
      skeletonWidths: ['100%'],
    },
    {
      key: 'status',
      label: 'Status',
      type: 'custom',
      customRender: (value: string, row: Record<string, unknown>, listingType: string) => (
        <PortalCellStatus value={value} row={row} listingType={listingType} />
      ),
      skeletonCount: 1,
      width: '20%',
      skeletonWidths: ['100%'],
    },
    {
      key: 'mobileOnly',
      label: 'Overview',
      type: 'custom',
      customRender: (value: string, row: Record<string, unknown>, listingType: string) => (
        <PortalCellMobile value={value} row={row} listingType={listingType} />
      ),
      skeletonCount: 1,
      width: '100%',
    },
    {
      key: 'url',
      label: '',
      type: 'custom',
      customRender: (value: string, row: Record<string, unknown>, listingType: string) => (
        <PortalCellUrl value={value} row={row} listingType={listingType} />
      ),
      skeletonCount: 1,
      width: '5%',
      skeletonWidths: ['90%'],
    },
  ],
  invoices: [
    {
      key: 'checkbox',
      label: '',
      type: 'custom',
      skeletonCount: 1,
      width: '20%',
      skeletonWidths: ['90%'],
    },
    {
      key: 'referenceId',
      label: 'Reference ID',
      type: 'custom',
      customRender: (value: string, row: Record<string, unknown>, listingType: string) => (
        <PortalCellReferenceId value={value} row={row} listingType={listingType} />
      ),
      skeletonCount: 1,
      width: '100%',
      skeletonWidths: ['90%'],
    },
    {
      key: 'dateIssued',
      label: 'Date Issued',
      type: 'custom',
      customRender: (value: string, row: Record<string, unknown>, listingType: string) => (
        <PortalCellDateIssued value={value} row={row} listingType={listingType} />
      ),
      skeletonCount: 2,
      width: '100%',
      skeletonWidths: ['50%', '80%'],
    },
    {
      key: 'dateDue',
      label: 'Due date',
      type: 'custom',
      customRender: (value: string, row: Record<string, unknown>, listingType: string) => (
        <PortalCellDateDue value={value} row={row} listingType={listingType} />
      ),
      skeletonCount: 2,
      width: '100%',
      skeletonWidths: ['50%', '80%'],
    },
    {
      key: 'total',
      label: 'Total',
      type: 'custom',
      customRender: (value: string, row: Record<string, unknown>, listingType: string) => (
        <PortalCellTotal value={value} row={row} listingType={listingType} />
      ),
      skeletonCount: 2,
      width: '100%',
      skeletonWidths: ['50%', '80%'],
    },
    {
      key: 'outstandingBalance',
      label: 'Left to pay',
      type: 'custom',
      customRender: (value: string, row: Record<string, unknown>, listingType: string) => (
        <PortalCellOutstandingBalance value={value} row={row} listingType={listingType} />
      ),
      skeletonCount: 2,
      width: '100%',
      skeletonWidths: ['50%', '80%'],
    },
    {
      key: 'status',
      label: 'Status',
      type: 'custom',
      customRender: (value: string, row: Record<string, unknown>, listingType: string) => (
        <PortalCellStatus value={value} row={row} listingType={listingType} />
      ),
      skeletonCount: 1,
      width: '100%',
      skeletonWidths: ['80%'],
    },
    {
      key: 'pay',
      label: '',
      type: 'custom',
      customRender: (value: string, row: Record<string, unknown>, listingType: string) => (
        <PortalCellPay value={value} row={row} listingType={listingType} />
      ),
      skeletonCount: 1,
      width: '10%',
      skeletonWidths: ['90%'],
    },
    {
      key: 'mobileOnly',
      label: 'Overview',
      type: 'custom',
      customRender: (value: string, row: Record<string, unknown>, listingType: string) => (
        <PortalCellMobile row={row} listingType={listingType} />
      ),
      skeletonCount: 1,
      width: '100%',
    },
  ],
  serviceListingJobs: [
    {
      key: 'jobDate',
      label: 'Date',
      type: 'custom',
      customRender: (value: string, row: Record<string, unknown>, listingType: string) => (
        <PortalCellDate value={value} row={row} listingType={listingType} />
      ),
      width: '100%',
      skeletonWidths: ['30%', '50%'],
    },
    {
      key: 'serviceName',
      label: 'Services',
      type: 'custom',
      customRender: (value: string, row: Record<string, unknown>, listingType: string) => (
        <PortalCellService value={value} row={row} listingType={listingType} />
      ),
      width: '100%',
      skeletonWidths: ['30%', '50%'],
    },
    {
      key: 'action',
      label: 'Job',
      type: 'custom',
      customRender: (value: string, row: Record<string, unknown>, listingType: string) => <p>{value}</p>,
      width: '100%',
      skeletonWidths: ['30%', '50%'],
    },
    {
      key: 'siteName',
      label: 'Location',
      type: 'custom',
      customRender: (value: string, row: Record<string, unknown>, listingType: string) => <div>{value}</div>,
      width: '100%',
      skeletonWidths: ['30%', '50%'],
    },
    {
      key: 'status',
      label: 'Status',
      type: 'custom',
      customRender: (value: string, row: Record<string, unknown>, listingType: string) => (
        <PortalCellStatus value={value} row={row} listingType={listingType} />
      ),
      width: '100%',
      skeletonWidths: ['30%', '50%'],
    },
    {
      key: 'attachments',
      label: 'Attachments',
      type: 'custom',
      customRender: (value: string, row: Record<string, unknown>, listingType: string) => (
        <PortalCellAttachments row={row} listingType={listingType} />
      ),
      width: '100%',
      skeletonWidths: ['30%', '50%'],
    },
    {
      key: 'mobileOnly',
      label: 'Overview',
      type: 'custom',
      customRender: (value: string, row: Record<string, unknown>, listingType: string) => (
        <PortalCellMobile row={row} listingType={listingType} />
      ),
      skeletonCount: 1,
      width: '100%',
    },
    {
      key: 'url',
      label: '',
      type: 'custom',
      customRender: (value, row, listingType) => <PortalCellUrl row={row} listingType={listingType} />,
    },
  ],
  jobs: [
    {
      key: 'jobDate',
      label: 'Date',
      type: 'custom',
      customRender: (value: string, row: Record<string, unknown>, listingType: string) => (
        <PortalCellDate value={value} row={row} listingType={listingType} />
      ),
      width: '100%',
      skeletonCount: 2,
      skeletonWidths: ['30%', '50%'],
    },
    {
      key: 'serviceName',
      label: 'Services',
      type: 'custom',
      customRender: (value: string, row: Record<string, unknown>, listingType: string) => (
        <PortalCellService value={value} row={row} listingType={listingType} />
      ),
      width: '100%',
      skeletonCount: 2,
      skeletonWidths: ['50%', '40%'],
    },
    {
      key: 'action',
      label: 'Job',
      type: 'custom',
      customRender: (value: string, row: Record<string, unknown>, listingType: string) => (
        <div className="portal-cell">
          <p>{value}</p>
        </div>
      ),
      width: '100%',
      skeletonCount: 1,
      skeletonWidths: ['30%'],
    },
    {
      key: 'siteName',
      label: 'Location',
      type: 'custom',
      customRender: (value: string, row: Record<string, unknown>, listingType: string) => (
        <PortalCellSite value={value} row={row} listingType={listingType} />
      ),
      width: '100%',
      skeletonCount: 3,
      skeletonWidths: ['90%', '50%', '30%'],
    },
    {
      key: 'status',
      label: 'Status',
      type: 'custom',
      customRender: (value: string, row: Record<string, unknown>, listingType: string) => (
        <PortalCellStatus value={value} row={row} listingType={listingType} />
      ),
      width: '100%',
      skeletonCount: 1,
      skeletonWidths: ['50%'],
    },
    {
      key: 'attachments',
      label: 'Attachments',
      type: 'custom',
      customRender: (value: string, row: Record<string, unknown>, listingType: string) => (
        <PortalCellAttachments row={row} listingType={listingType} />
      ),
      width: '100%',
      skeletonCount: 1,
      skeletonWidths: ['60%'],
    },
    {
      key: 'mobileOnly',
      label: 'Overview',
      type: 'custom',
      customRender: (value: string, row: Record<string, unknown>, listingType: string) => (
        <PortalCellMobile row={row} listingType={listingType} />
      ),
      skeletonCount: 1,
      width: '100%',
    },
    {
      key: 'url',
      label: '',
      screenReaderLabel: 'View Page URL',
      type: 'custom',
      customRender: (value: string, row: Record<string, unknown>, listingType: string) => (
        <PortalCellUrl row={row} listingType={listingType} />
      ),
      skeletonCount: 1,
      width: '100%',
      skeletonWidths: ['0%'],
    },
  ],
};
